






























































import { onMounted, defineComponent, computed } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { BaseStatusBadge, IconSize, StatusType } from '@getaccept/lib-ui';
import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import { TooltipPlacement } from '@getaccept/lib-shared/src/enums/tooltip-placement';

import { languageLoaded } from '../../lang';
import { useSidebarItemsStore } from '../store/sidebar-items.store';
import { useModulesStore } from '../../modules/store/modules.store';
import SubscriptionInfoButton from '../../subscription/components/SubscriptionInfoButton.vue';
import { useSubscriptionStore } from '../../subscription/store/subscription.store';
import GlobalSidebarIconActive from './GlobalSidebarIconActive.vue';
import GlobalSidebarIcon from './GlobalSidebarIcon.vue';
import ProductSwitcher from './ProductSwitcher.vue';
import { useSidebarStore } from './store/sidebar.store';
import GlobalSidebarContainer from './GlobalSidebarContainer.vue';

export default defineComponent({
  components: {
    GlobalSidebarContainer,
    GlobalSidebarIconActive,
    GlobalSidebarIcon,
    ProductSwitcher,
    BaseStatusBadge,
    SubscriptionInfoButton,
  },
  setup() {
    const { isXSmallScreen, isXXSmallScreen } = useBreakpoints();
    const store = useSidebarStore();
    const { compact } = storeToRefs(store);
    const sidebarItemsStore = useSidebarItemsStore();
    const modulesStore = useModulesStore();

    const subscriptionStore = useSubscriptionStore();
    // eslint-disable-next-line no-restricted-syntax
    const { isInactiveSubscription, isTrialPlan, daysLeft } = storeToRefs(subscriptionStore);

    const showSubscriptionButton = computed(
      // eslint-disable-next-line no-restricted-syntax
      () => isTrialPlan.value && !isInactiveSubscription.value
    );

    const showProductSwitcher = computed(
      () =>
        modulesStore.hasContractRoomModuleAccess &&
        modulesStore.hasDealRoomModuleAccess &&
        !isInactiveSubscription.value
    );

    const setDefaultMenuMode = () => {
      if (isXSmallScreen.value || isXXSmallScreen.value) {
        store.setCompact(true);
      }
    };

    onMounted(() => {
      setDefaultMenuMode();
      window.addEventListener('resize', setDefaultMenuMode);
    });

    return {
      compact,
      toggleSidebar: store.toggleSideBar,
      IconSize,
      languageLoaded,
      StatusType,
      TooltipPlacement,
      showSubscriptionButton,
      sidebarItemsStore,
      modulesStore,
      isInactiveSubscription,
      daysLeft,
      showProductSwitcher,
    };
  },
});
